import { buildImageProviderOptionsForRequest } from '../image/build-image-provider-options';
import { getEffectiveImageConfig, resolveImageMode } from '../image/types';
import { ceilCredits } from './credits';

type ImageNodeLikeData = {
  size?: string;
  imagesCount?: number;
  image_resolution?: string;
  model?: string;
  imageMode?: string;
  modelUi?: Record<string, any>;
};

function resolveImageEstimateParams(params: { model: any; nodeData: ImageNodeLikeData | any }) {
  const { model, nodeData } = params;
  const provider = (model as any)?.providers?.[0];

  // 默认尺寸按模式取有效配置（兼容只配 configByMode 的模型）
  const effSizes = getEffectiveImageConfig(model, (nodeData as any)?.imageMode).sizes;
  const size =
    (nodeData as any)?.size ||
    (Array.isArray(effSizes) && effSizes.length > 0 ? effSizes[0] : '1024x1024');

  const imagesCount = Number((nodeData as any)?.imagesCount ?? 1);
  const safeCount = Number.isFinite(imagesCount) && imagesCount > 0 ? imagesCount : 1;

  const modelId = String((nodeData as any)?.model ?? '').trim();
  const modelUi = ((nodeData as any)?.modelUi ?? {}) as Record<string, any>;
  const image_resolution = (nodeData as any)?.image_resolution as string | undefined;
  const providerOptions = modelId
    ? buildImageProviderOptionsForRequest({ modelId, modelUi, image_resolution })
    : {};

  const mode = resolveImageMode(model, (nodeData as any)?.imageMode);

  return { provider, size, safeCount, providerOptions, mode };
}

export function estimateImageUsdCost(params: { model: any; nodeData: ImageNodeLikeData | any }) {
  try {
    const { provider, size, safeCount, providerOptions, mode } = resolveImageEstimateParams(params);
    if (!provider || typeof provider.getCost !== 'function') return null;

    const perImageUsd = Number(provider.getCost({ size, providerOptions, mode }) ?? 0);
    if (!Number.isFinite(perImageUsd)) return null;
    return perImageUsd * safeCount;
  } catch {
    return null;
  }
}

export function estimateImagePassCount(params: { model: any; nodeData: ImageNodeLikeData | any }): number {
  try {
    const { provider, size, safeCount, providerOptions } = resolveImageEstimateParams(params);
    if (!provider || typeof provider.getPassCount !== 'function') return safeCount;

    const perImage = Number(provider.getPassCount({ size, providerOptions }) ?? 1);
    if (!Number.isFinite(perImage) || perImage <= 0) return safeCount;
    return ceilCredits(perImage * safeCount);
  } catch {
    return 1;
  }
}
